(function () {
  'use strict';

  function initDirectCheckout(section) {
    var form = section.querySelector('form.product__form');
    var trigger = form && form.querySelector('[data-ginyhome-quick-purchase-trigger]');
    var errorContainer = form && form.querySelector('[data-cart-errors-container]');
    var inFlight = false;

    if (!form || !trigger) return;

    function setError(message) {
      if (!errorContainer) return;
      errorContainer.textContent = message || '';
      errorContainer.hidden = !message;
    }

    function resetCheckoutState() {
      inFlight = false;
      trigger.disabled = false;
      trigger.removeAttribute('aria-busy');
      trigger.removeAttribute('aria-disabled');
    }

    function currentPurchase() {
      var formData = new FormData(form);
      var variantInput = form.querySelector('[data-product-select]') || form.querySelector('[name="id"]');
      var variantId = String(formData.get('id') || (variantInput && (variantInput.value || variantInput.getAttribute('value'))) || '').trim();
      if (!variantId) {
        try {
          variantId = String(new URL(window.location.href).searchParams.get('variant') || '').trim();
        } catch (error) {
          variantId = '';
        }
      }
      var quantity = Number(formData.get('quantity'));
      var attributes = [];

      formData.forEach(function (value, name) {
        var match = name.match(/^properties\[(.*)\]$/);
        if (!match || value instanceof File || String(value).trim() === '') return;
        attributes.push({ key: match[1], value: String(value) });
      });

      return { variantId: variantId, quantity: quantity, attributes: attributes };
    }

    function buildRequest() {
      var currentState = form.getAttribute('data-ginyhome-customizer-state');
      var purchase = currentPurchase();

      if (currentState === 'incomplete' || currentState === 'loading') {
        throw new Error('Completa la personalizzazione prima di procedere.');
      }
      if (!/^\d+$/.test(purchase.variantId)) throw new Error('Seleziona una variante disponibile.');
      if (!Number.isInteger(purchase.quantity) || purchase.quantity < 1) throw new Error('Seleziona una quantità valida.');

      return {
        query: 'mutation cartCreate($input: CartInput!) { cartCreate(input: $input) { cart { id checkoutUrl } userErrors { field message } } }',
        variables: {
          input: {
            lines: [{
              quantity: purchase.quantity,
              merchandiseId: 'gid://shopify/ProductVariant/' + purchase.variantId,
              attributes: purchase.attributes
            }]
          }
        }
      };
    }

    function startCheckout(event) {
      event.preventDefault();
      if (inFlight) return;

      inFlight = true;
      trigger.disabled = true;
      trigger.setAttribute('aria-busy', 'true');
      trigger.setAttribute('aria-disabled', 'true');
      setError('');

      var request;
      try {
        request = buildRequest();
      } catch (error) {
        setError(error.message || 'Impossibile preparare il checkout.');
        resetCheckoutState();
        return;
      }

      fetch('https://vilabsrl.myshopify.com/api/2026-07/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request)
      }).then(function (response) {
        if (!response.ok) throw new Error('Storefront request failed.');
        return response.json();
      }).then(function (payload) {
        if (payload.errors && payload.errors.length) throw new Error('Storefront request failed.');
        var result = payload.data && payload.data.cartCreate;
        if (result && result.userErrors && result.userErrors.length) throw new Error('Checkout non disponibile.');
        var checkoutUrl = result && result.cart && result.cart.checkoutUrl;
        var parsedUrl;
        try {
          parsedUrl = checkoutUrl && new URL(checkoutUrl);
        } catch (error) {
          parsedUrl = null;
        }
        if (!parsedUrl || !/^https?:$/.test(parsedUrl.protocol)) throw new Error('Checkout non disponibile.');
        window.location.href = checkoutUrl;
      }).catch(function (error) {
        setError(error.message === 'Checkout non disponibile.' ? error.message : 'Impossibile aprire il checkout. Riprova.');
        resetCheckoutState();
      });
    }

    trigger.addEventListener('click', startCheckout);
    window.addEventListener('pageshow', function () {
      resetCheckoutState();
      setError('');
    });
  }

  function boot() {
    document.querySelectorAll('[data-section-type="product-template"]').forEach(initDirectCheckout);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
}());
